import { AnyAction } from 'redux';

import {
    STATIC_SITES_DETAIL_CREATE,
    STATIC_SITES_DETAIL_ERROR,
    STATIC_SITES_DETAIL_FETCH,
    STATIC_SITES_DETAIL_RECEIVE,
    STATIC_SITES_DETAIL_RECEIVE_NON_UNIQUE_PROPERTIES,
    STATIC_SITES_DETAIL_RESET,
    STATIC_SITES_DETAIL_UPDATE,
} from './static-sites-detail-actions';
import { StaticSites } from '../models/static-sites';

export interface StaticSitesDetailReducerState {
    staticSites: StaticSites | null;
    requesting: boolean;
    hasNonUniqueProperties: boolean;
}

const initialStaticSitesListReducerState: StaticSitesDetailReducerState = {
    staticSites: null,
    requesting: false,
    hasNonUniqueProperties: false,
};

export const staticSitesDetailReducer = (
    state: StaticSitesDetailReducerState = initialStaticSitesListReducerState,
    action: AnyAction
): StaticSitesDetailReducerState => {
    switch (action.type) {
        case STATIC_SITES_DETAIL_RESET: {
            return {
                ...state,
                staticSites: null,
                hasNonUniqueProperties: false,
            };
        }

        case STATIC_SITES_DETAIL_FETCH:
        case STATIC_SITES_DETAIL_CREATE:
        case STATIC_SITES_DETAIL_UPDATE: {
            return {
                ...state,
                requesting: true,
                hasNonUniqueProperties: false,
            };
        }

        case STATIC_SITES_DETAIL_RECEIVE_NON_UNIQUE_PROPERTIES: {
            return {
                ...state,
                hasNonUniqueProperties: true,
                requesting: false,
            };
        }

        case STATIC_SITES_DETAIL_RECEIVE: {
            return {
                ...state,
                requesting: false,
                hasNonUniqueProperties: false,
                staticSites: action['staticSites'],
            };
        }

        case STATIC_SITES_DETAIL_ERROR: {
            return {
                ...state,
                requesting: false,
            };
        }

        default: {
            return state;
        }
    }
};
